import { Button, FormControl, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";

import { useApi } from "../../context/context";

import styles from "./DropDown.module.scss";

function DropDown() {
  const { userCompanies, companyId, setState } = useApi();
  const [selectedCompany, setSelectedCompany] = useState(companyId);
  const navigate = useNavigate();

  if (!userCompanies || userCompanies.length === 0) return null;

  const companies = userCompanies.map(({ CompanyId, CompanyName }) => (
    <MenuItem key={CompanyId} value={CompanyId}>
      {CompanyName}
    </MenuItem>
  ));

  const handleChange = (e) => {
    const _companyId = e.target.value;
    setSelectedCompany(_companyId);
  };

  const handleContinue = (e) => {
    e.preventDefault();
    localStorage.setItem("companyId", selectedCompany);
    setState((prev) => ({
      ...prev,
      projects: [],
      orders: [],
      contacts: "",
      invoices: [],
      companyId: selectedCompany,
      company: "",
      notifications: [],
      companySalesPerson: ""
    }));
    navigate("/", { replace: true });
  };

  return (
    <div className={styles.container}>
      <FormControl fullWidth>
        <Select
          displayEmpty
          value={selectedCompany}
          onChange={handleChange}
          aria-label="Select Company"
        >
          <MenuItem key="default" value="">
            Choose a company
          </MenuItem>
          {companies}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        fullWidth
        disableElevation
        sx={{ mt: styles.spacing, p: 2, borderRadius: "100px" }}
        onClick={handleContinue}
        disabled={!selectedCompany}
      >
        Continue
      </Button>
    </div>
  );
}

export default DropDown;
